import styled, { css } from 'styled-components';

import { TransitionDuration } from 'design-system/variables/transitions';
import ImageIdFrontGuide from 'images/pictographs/id-front-guide.svg';
import IdCornersGuide from 'inquiry/components/ScannerOverlay/IdCornersGuide';

const Positioner = styled('div')<{ mirrored: boolean }>`
  ${({ mirrored }) =>
    mirrored &&
    css`
      transform: scale(-1, 1);
    `};
  width: 100%;
`;

interface IdFrontGuideProps {
  mirrored?: boolean;
  hideGuide?: boolean;
  highlightCorners?: boolean;
}

export default function IdFrontGuide({
  mirrored = false,
  hideGuide = false,
  highlightCorners = false,
}: IdFrontGuideProps) {
  return (
    <Positioner data-test='id-front-guide' mirrored={mirrored}>
      <div
        style={{
          position: 'relative',
        }}
      >
        <IdCornersGuide highlightCorners={highlightCorners} />
        <ImageIdFrontGuide
          style={{
            objectFit: 'cover',
            opacity: hideGuide ? 0 : 1,
            transition: `opacity ${TransitionDuration.Fast}`,
          }}
        />
      </div>
    </Positioner>
  );
}
